import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Plus, UserRound } from "lucide-react";
import { toast } from "sonner";
import { api, fmtDate, SIDE_FR } from "../../lib/api";
import { usePatients } from "../../hooks/useData";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { PageHeader } from "./CareLayout";
import { EMPTY_PATIENT, PatientForm } from "./PatientForm";

export default function Patients() {
  const nav = useNavigate();
  const qc = useQueryClient();
  const { data: patients } = usePatients();
  const [open, setOpen] = useState(false);
  const create = async (f) => {
    const { data } = await api.post("/patients", f);
    qc.invalidateQueries({ queryKey: ["patients"] });
    toast.success("Profil patient créé");
    setOpen(false);
    nav(`/care/patients/${data.id}`);
  };
  return (
    <div data-testid="care-patients">
      <PageHeader title="Patients" sub="Profils cliniques et restrictions">
        <button data-testid="new-patient-button" onClick={() => setOpen(true)} className="flex h-11 items-center gap-2 rounded-xl bg-brand px-4 text-sm font-bold text-white"><Plus className="h-4 w-4" />Nouveau patient</button>
      </PageHeader>
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {patients?.map((p) => (
          <Link key={p.id} to={`/care/patients/${p.id}`} data-testid={`patient-card-${p.id}`}
            className="group rounded-2xl border border-border bg-card p-5 transition-shadow hover:shadow-lg">
            <div className="flex items-center gap-3">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary/10"><UserRound className="text-[#17A2A2]" /></span>
              <div><p className="font-display text-lg font-bold">{p.name}{p.is_demo && <span className="ml-2 rounded bg-amber-100 px-1.5 py-0.5 text-[10px] font-bold text-amber-800">DÉMO</span>}</p>
                <p className="text-sm text-muted-foreground">{p.age} ans · {p.clinical_profile.diagnosis_label}</p></div>
            </div>
            <div className="mt-4 grid grid-cols-3 gap-2 text-center text-xs">
              <div className="rounded-xl bg-muted p-2"><p className="text-muted-foreground/80">Côté atteint</p><p className="font-bold">{SIDE_FR[p.clinical_profile.affected_side]}</p></div>
              <div className="rounded-xl bg-muted p-2"><p className="text-muted-foreground/80">Séances</p><p className="font-bold">{p.sessions_done}</p></div>
              <div className="rounded-xl bg-muted p-2"><p className="text-muted-foreground/80">Dernière</p><p className="font-bold">{fmtDate(p.last_session_at)}</p></div>
            </div>
          </Link>
        ))}
      </div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[90vh] max-w-4xl overflow-y-auto bg-background">
          <DialogHeader><DialogTitle className="font-display text-2xl">Nouveau profil patient</DialogTitle></DialogHeader>
          <PatientForm initial={EMPTY_PATIENT} onSubmit={create} submitLabel="Créer le profil" />
        </DialogContent>
      </Dialog>
    </div>
  );
}
